import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20illustration%20collage%2C%20vibrant%20warm%20tones%20of%20coral%20pink%20and%20golden%20yellow%2C%20abstract%20geometric%20shapes%20with%20soft%20gradients%2C%20modern%20minimalist%20composition%2C%20clean%20artistic%20background%2C%20editorial%20design%20aesthetic%2C%20no%20text%2C%20smooth%20color%20transitions%2C%20dreamy%20atmosphere&width=1920&height=1080&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30" />

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-6 md:px-10">
          <div className="max-w-2xl">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-400 text-xs font-medium mb-6 backdrop-blur-sm">
              每日更新 · 免费阅读
            </span>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-black font-heading text-background-50 leading-tight tracking-tight">
              汗汗漫画
            </h1>
            <p className="mt-6 text-lg md:text-xl text-background-50/80 leading-relaxed max-w-xl">
              免费韩国漫画在线阅读平台，汇集海量韩漫大全<br />
              涵盖恋爱、悬疑、奇幻等热门题材，无需付费即可畅享正版韩漫资源
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-start gap-4">
              <Link
                to="/category/lianai"
                className="px-8 py-3.5 rounded-full bg-accent-500 text-foreground-950 text-sm font-bold hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即阅读
                <div className="inline-flex w-4 h-4 items-center justify-center ml-2">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 rounded-full border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>

            <div className="mt-12 flex items-center gap-8">
              <div>
                <p className="text-3xl md:text-4xl font-bold text-accent-400">2000+</p>
                <p className="text-sm text-background-50/60 mt-1">漫画资源</p>
              </div>
              <div className="w-px h-10 bg-background-50/20" />
              <div>
                <p className="text-3xl md:text-4xl font-bold text-accent-400">500万+</p>
                <p className="text-sm text-background-50/60 mt-1">活跃读者</p>
              </div>
              <div className="w-px h-10 bg-background-50/20" />
              <div>
                <p className="text-3xl md:text-4xl font-bold text-accent-400">日更</p>
                <p className="text-sm text-background-50/60 mt-1">每日更新</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-2xl text-background-50/60"></i>
        </div>
      </div>
    </section>
  );
}